<template>
  <div>
    <h3 class="mb-3">Восстановления</h3>

    <player-restorations-table
      v-if="isRestorationsVisible"
      :playerId="playerId"
      :restorations="restorations"
    />

    <p v-if="message !== null">
      {{ message }}
    </p>

    <loading-indicator v-if="isLoading"/>
  </div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

import LoadingIndicator   from './LoadingIndicator.vue';
import PlayerRestorationsTable from './PlayerRestorationsTable.vue';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'PlayerRestorations',

  components: {
    LoadingIndicator,
    PlayerRestorationsTable,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      loadingStatus: LOADING_STATUS__INIT,
      restorations: null,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadingStatus === LOADING_STATUS__LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadingStatus === LOADING_STATUS__NORMAL;
    },

    /** @returns {?string} */
    message() {
      if(!this.isLoadedNormal) {
        return null;
      }

      const restorations = this.restorations;
      if(restorations !== null && restorations.length === 0) {
        return 'У этого игрока не было восстановлений.';
      }

      return null;
    },

    /** @returns {boolean} */
    isRestorationsVisible() {
      if(!this.isLoadedNormal) {
        return false;
      }

      const restorations = this.restorations;
      if(restorations === null) {
        return false;
      }

      return restorations.length > 0;
    },
  },

  created() {
    this.loadPlayerRestorations();
  },

  methods: {
    loadPlayerRestorations() {
      notifier.deleteSenderNotifications(this);

      this.loadingStatus = LOADING_STATUS__LOADING;

      const url = '/player/' + this.playerId + '/restorations';
      HTTP.get(url)
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          this.loadingStatus = LOADING_STATUS__ERROR;
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        this.restorations = data;
        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },
  },
}
</script>
